import React from 'react'
import PropType from 'prop-types'
import Actions from '@material-ui/core/CardActions'

const CardActions = ({ children }) => (
  <Actions disableSpacing>
    { children }
  </Actions>
)

CardActions.defaultProps = {
  children: null,
}

CardActions.propTypes = {
  children: PropType.node,
}

export default CardActions
